"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.form.title.label': 'Tytuł Pytania <span class="text-danger">*</span>',
    'question.form.title.placeholder': 'Wprowadź tytuł pytania',
    'question.form.type.label': 'Typ Pytania',
    'question.form.type.placeholder': 'Wybierz typ pytania',
    'question.form.required.label': 'Wymagane',
    'question.form.description.label': 'Opis (Opcjonalny)',
    'question.form.description.placeholder': 'Wprowadź opis pytania',
    'question.form.options.label': 'Opcje',
    'question.form.options.add': 'Dodaj Opcję',
    'question.form.option.value.placeholder': 'Wartość opcji',
    'question.form.option.label.placeholder': 'Etykieta opcji',
    'question.form.option.remove': 'Usuń opcję',
    'question.form.options.empty': 'Nie dodano jeszcze żadnych opcji. Kliknij "Dodaj Opcję", aby rozpocząć.',
};
